import React from 'react'
import { Poptart } from 'sidecar-components'

import { MemberCommsPoptartContent } from './MemberCommsPoptartContent'
import { useMemberComms } from 'hooks/useMemberComms'

/**
 * @param {string} className - Optional string to be passed to the poptart.
 *   Mainly used to adjust the z-index for focusing one poptart over another in
 *   mobile.
 * @param {function} onClick - Optional function fired when you click the
 *   poptart. Mainly used to adjust the z-index for focusing one poptart over
 *   another in mobile.
 * @returns {JSX.Element} A Poptart component that contains the form to create
 *   an inbox ticket assistant.
 */
export const MemberCommsPoptart = ({ className = '', onClick }) => {
  // Get state and handlers from context
  const {
    isOpen,
    isMaximized,
    handleClose,
    toggleMaximize,
    requestTitle,
    poptartHistory,
    prevHistory,
    clearNewMessage,
    clearRequestType,
    clearPopTartHistory,
    closePoptart,
  } = useMemberComms()

  // Clear data logic
  const clearData = () => {
    clearNewMessage()
    clearRequestType()
    clearPopTartHistory()
    handleClose() // Also close the poptart
  }

  // History navigation logic (from local Poptart)
  const goBack = () => {
    if (poptartHistory?.length === 0) {
      clearData()
    } else {
      prevHistory()
    }
  }

  // Handle close with our custom confirmation logic
  const handleCloseWithConfirmation = open => {
    if (!open) {
      clearData()
    }
  }
  // Don't render if not open
  if (!isOpen) return null

  return (
    <Poptart
      testId="memberCommsPoptart"
      title={requestTitle || 'New message'}
      bodyClass="!p-0"
      isOpen={isOpen}
      isMaximized={isMaximized}
      onOpenChange={handleCloseWithConfirmation}
      onMaximizeChange={toggleMaximize}
      onBack={goBack}
      onClick={onClick}
      onClose={clearData}
      confirmCloseTitle={'Are you sure you want to close your message'}
      confirmCloseSubtitle={`You will lose any progress you\u2019ve made.`}
      confirmCloseButton={'Close form'}
      canCollapse={true}
      className={className}
    >
      <MemberCommsPoptartContent
        requestTitle={requestTitle}
        closePoptart={closePoptart}
      />
    </Poptart>
  )
}
